<sf-page-title
    title="Orders"
    icon="shopping-cart"
    description="Manage and review all orders placed through Surefire. This section provides an overview of previously placed orders, allowing you to track order status and details efficiently.">
</sf-page-title>

<sf-card>
    <div class="row">
        <div class="col-md-6">
            <sf-calendar-range-selector
                [startDate]="filter().from!"
                [endDate]="filter().to!"
                (dateRangeChange)="onDateChanged($event)">
            </sf-calendar-range-selector>
        </div>
    </div>
    @if (orders.hasValue()) {
        <sf-orders-table [orders]="orders.value()!.items"></sf-orders-table>

        @if (orders.value()!.items.length > 0) {
            <sf-pagination-detail
                [paginationData]="orders.value()!"
                (onPageChange)="onPageChanged($event)"></sf-pagination-detail>
        }
    }
</sf-card>
